import { useQueryUserBillingInfo } from '../../data/query/useQueryUserBillingInfo';
import { isClinicianMaxBillingSeat } from './is-clinician-max-billing-seat';

/** True when billing reports Clinician Pro on a Max seat. */
export function useIsClinicianMaxBillingSeat(): boolean {
  const { data: billingInfo } = useQueryUserBillingInfo();
  return isClinicianMaxBillingSeat(billingInfo);
}
